import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import * as actionTypes from '../constants/course-evaluation-template-action-types';

import type {Map} from 'immutable';

export type CourseEvaluationTemplateStore = {
    evaluationTemplate: Map<unknown, unknown>;
};

const initialState = () => {
    return {
        evaluationTemplate: Immutable.Map(),
    };
};

const actionsMap = {
    [actionTypes.GET_EVALUATION_TEMPLATE_SUCCESS]: (state, action) => {
        return {
            evaluationTemplate: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<CourseEvaluationTemplateStore>(initialState(), actionsMap);
